import { FunctionComponent } from "react";
import { GameInfoProps } from "../../type";
import { Rule } from "./type";
import RoosterBlitzUtils from "./utils";

export const RoosterBlitzRuleView: FunctionComponent<GameInfoProps> = ({
  data,
}) => {
  const {
    payouts = {},
    buyFreeSpinRate = 50,
    givenFreeSpin = {},
  } = data as Rule;
  const candyPayouts = Object.entries(payouts);
  const halfCandyCount = candyPayouts.length / 2;
  const payoutElement = [
    <tr key={2} className="text-center">
      {candyPayouts.slice(halfCandyCount).map(([symbol, payout], i) => (
        <td key={`symbol-${symbol}`}>
          <div className="d-inline-block symbol">
            {RoosterBlitzUtils.convertSymbol(+symbol)}
          </div>
          <div className="">{payout}</div>
        </td>
      ))}
    </tr>,
    <tr key={1} className="text-center">
      {candyPayouts.slice(0, halfCandyCount).map(([symbol, payout], i) => (
        <td key={`symbol-${symbol}`}>
          <div className="d-inline-block symbol">
            {RoosterBlitzUtils.convertSymbol(+symbol)}
          </div>
          <div className="">{payout}</div>
        </td>
      ))}
    </tr>,
  ];
  const specialSymbols = [
    <tr key={1} className="text-center">
      {[4, 2, 3].map((symbol) => (
        <td key={`symbol-${symbol}`}>
          <div className="d-inline-block symbol">
            {RoosterBlitzUtils.convertSymbol(+symbol)}
          </div>
        </td>
      ))}
    </tr>,
  ];
  return (
    <>
      <h5 className="card-title">Game Rules</h5>
      <div className="card-text">
        <h6>Payout Table</h6>
        <br />
        <table className="w-100">
          <tbody>{payoutElement}</tbody>
        </table>
      </div>
      <p className="card-text">
        Match four or more symbols for a win!
        <br />
        Matched symbols explode and trigger a cascade of new symbols.
      </p>
      <p className="card-text">
        Scoring continues until no further matches are possible.
      </p>
      <p className="card-text">Malfunction voids all wins and plays</p>
      <h6>Free Spin Meter</h6>
      <p className="card-text">
        A round of match advances the meter by 1.
        <br />
        Collecting 4 symbols awards free spins and transforms the bar
        <br />
      </p>
      <h6>Buy Free Spins</h6>
      <p className="card-text">
        <br />
        <div className="buyfreespins-rule-bg">
          <img
            className="freespin-rule-btn-img"
            src="/rb/buyfreespins.png"
            alt="buyfreespins"
            height="50px"
          />
        </div>
        <br />
        Pay 50x your total bet to trigger Free Spin Mode with at least 5 free
        spins and a chance for more!
      </p>
      <h6>Free Spin Mode</h6>
      <p className="card-text">
        Free spins are rewarded equal to the threshold reached on the Free Spin
        Meter.
        <br />
        During free spin, all wins are 2x of a regular round's payout.
        <br />
        During free spin, Rooster Flurry wins are 10x of a regular round's
        payout.
      </p>
      <h6>Rooster Flurry</h6>
      <p className="card-text">
        Combining three or more special symbols initiates Rooster Flurry,
        removing all symbols.
        <br />
        In normal spin, Rooster Flurry awards 2x payout.
        <br />
        In free spin, Rooster Flurry awards 10x payout.
      </p>
      <p className="card-text">
        During a round, each respin or successful combination increases the
        progress bar for free spins.
      </p>
      <br />
      <h6>Special Symbols</h6>
      <div className="d-inline-block symbol">
        {RoosterBlitzUtils.convertSymbol(+4)}
      </div>
      Rooster Kick
      <p>
        Matching five identical symbols forms a Rooster Kick.
        <br />
        It destroys all symbols in a line.
      </p>
      <div className="d-inline-block symbol">
        {RoosterBlitzUtils.convertSymbol(+3)}
      </div>
      Rooster Bomb
      <p>
        Matching six identical symbols forms a Rooster Bomb.
        <br />
        It destroys symbols within a 3x3 area.
      </p>
      <div className="d-inline-block symbol">
        {RoosterBlitzUtils.convertSymbol(+2)}
      </div>
      Mystery Trophy
      <p>
        Matching seven identical symbols forms a Mystery Trophy.
        <br />
        It randomly selects a symbol type and destroys all instances of it.
      </p>
      <div className="d-inline-block symbol">
        {RoosterBlitzUtils.convertSymbol(+4)}
      </div>
      <div className="d-inline-block symbol">
        {RoosterBlitzUtils.convertSymbol(+4)}
      </div>
      Rooster Kick + Rooster Kick
      <p>Symbols in a PLUS and CROSS shape will be destroyed.</p>
      <div className="d-inline-block symbol">
        {RoosterBlitzUtils.convertSymbol(+4)}
      </div>
      <div className="d-inline-block symbol">
        {RoosterBlitzUtils.convertSymbol(+3)}
      </div>
      Rooster Kick + Rooster Bomb
      <p>Symbols across three rows and columns are destroyed.</p>
      <div className="d-inline-block symbol">
        {RoosterBlitzUtils.convertSymbol(+4)}
      </div>
      <div className="d-inline-block symbol">
        {RoosterBlitzUtils.convertSymbol(+2)}
      </div>
      Rooster Kick + Mystery Trophy
      <p>
        A symbol type is randomly selected and all instances of if,
        <br />
        along with symbols in a row and column are destroyed.
      </p>
      <div className="d-inline-block symbol">
        {RoosterBlitzUtils.convertSymbol(+3)}
      </div>
      <div className="d-inline-block symbol">
        {RoosterBlitzUtils.convertSymbol(+3)}
      </div>
      Rooster Bomb + Rooster Bomb
      <p>All symbols within a 5x5 area are destroyed.</p>
      <div className="d-inline-block symbol">
        {RoosterBlitzUtils.convertSymbol(+3)}
      </div>
      <div className="d-inline-block symbol">
        {RoosterBlitzUtils.convertSymbol(+4)}
      </div>
      Rooster Bomb + Mystery Trophy
      <p>
        A randomly chosen symbol type and all symbols in a BOX shape around them
        are destroyed.
      </p>
      <div className="d-inline-block symbol">
        {RoosterBlitzUtils.convertSymbol(+3)}
      </div>
      <div className="d-inline-block symbol">
        {RoosterBlitzUtils.convertSymbol(+2)}
      </div>
      Mystery Trophy + Mystery Trophy
      <p>
        Three symbols types are randomly selected and all instances destroyed.
      </p>
    </>
  );
};
